<div class="content-label-container">
    <h1 translate>navigation.aboutus</h1>
</div>

<div class="content-main-container">
    <div class="aboutus_paragraph_emphasis">
        <span translate>aboutus.sentence01</span>
    </div>
    <div class="aboutus_paragraph">
        <span translate>aboutus.sentence02</span>
    </div>
    <div class="aboutus_paragraph">
        <span translate>aboutus.sentence03</span>
        <br>
        <span translate>aboutus.sentence04</span>
        <br>
        <span translate>aboutus.sentence05</span>
        <br>
        <span translate>aboutus.sentence06</span>
        <br>
        <span translate>aboutus.sentence07</span>
        <br>
        <span translate>aboutus.sentence08</span>
        <br>
        <span translate>aboutus.sentence09</span>
        <br>
        <span translate>aboutus.sentence10</span>
    </div>
    <div class="aboutus_paragraph">
        <span translate>aboutus.sentence11</span>
        <br>
        <span translate>aboutus.sentence12</span>
        <br>
        <span translate>aboutus.sentence13</span>
        <br>
        <span translate>aboutus.sentence14</span>
    </div>
    <div class="aboutus_paragraph">
        <span translate>aboutus.sentence15</span>
        <br>
        <span translate>aboutus.sentence16</span>
        <br>
        <span translate>aboutus.sentence17</span>
    </div>
    <div class="aboutus_paragraph_sub">
        <span class="title" translate>aboutus.sentence18</span>
        <br>
        <span translate>aboutus.sentence19</span>
        <br>
        <span translate>aboutus.sentence20</span>
    </div>
</div>
